export default function SET_STUDENT_PANEL(state, studentPanelData) {
    state.studentPanel = studentPanelData;
}